import { CateringTranslations } from "./catering-pt-br";

export const CATERING_ES_ES: CateringTranslations = {
	title: "Catering",
	description:
		"Gestiona el catering de tus eventos, recibe propuestas, envía presupuestos y monitorea todo en un solo lugar.",
};
